import React from 'react';

function Video1() {
    return (
      <div>
          <video width="100%" height="90%" loop autoplay="" muted="" playsinline="" poster="img/escritorio.jpg"> 
          <source src="http://www.criar.com.br/videos/escritorio.mp4" type="video/mp4" />
        </video>
      </div>
    );
  }

  function Video2() {
    return (
      <div>
          <video width="100%" height="90%" loop autoplay="" muted="" playsinline="" poster="img/escritorio.jpg"> 
          <source src="http://www.criar.com.br/videos/SolServicos.mp4" type="video/mp4" />
        </video>
      </div>
    );
  }



  function Video3() {
    return (
      <div>
          <video width="100%" height="90%" loop autoplay="" muted="" playsinline="" poster="img/escritorio.jpg"> 
          <source src="http://www.criar.com.br/videos/SolInfraestrutura.mp4" type="video/mp4" />
        </video>
      </div>
    );
  }

  function Video4() {
    return (
      <div>
          <video width="100%" height="90%" loop autoplay="" muted="" playsinline="" poster="img/escritorio.jpg"> 
          <source src="http://www.criar.com.br/videos/SolEquipamentos.mp4" type="video/mp4" />
        </video>
      </div>
    );
  }

  function Video5() {
    return (
      <div>
          <video width="100%" height="90%" loop autoplay="" muted="" playsinline="" poster="img/escritorio.jpg"> 
          <source src="http://www.criar.com.br/videos/SolProgamas.mp4" type="video/mp4" />
        </video>
      </div>
    );
  }


  function Video6() {
    return (
      <div>
          <video width="100%" height="90%" loop autoplay="" muted="" playsinline="" poster="img/escritorio.jpg"> 
          <source src="http://www.criar.com.br/videos/PDVs.mp4" type="video/mp4" />
        </video>
      </div>
    );
  }

  function Video7() {
    return (
      <div>
          <video width="100%" height="90%" loop autoplay="" muted="" playsinline="" poster="img/escritorio.jpg"> 
          <source src="http://www.criar.com.br/videos/Esta1.mp4" type="video/mp4" />
        </video>
      </div>
    );
  }

  function Video8() {
    return (
      <div>
          <video width="100%" height="90%" loop autoplay="" muted="" playsinline="" poster="img/escritorio.jpg"> 
          <source src="http://www.criar.com.br/videos/Esta2.mp4" type="video/mp4" />
        </video>
      </div>
    );
  }

  function Video9() {
    return (
      <div>
          <video width="100%" height="90%" loop autoplay="" muted="" playsinline="" poster="img/escritorio.jpg"> 
          <source src="http://www.criar.com.br/videos/Esta3.mp4" type="video/mp4" />
        </video>
      </div>
    );
  }

  function Video10() {
    return (
      <div>
          <video width="100%" height="90%" loop autoplay="" muted="" playsinline="" poster="img/escritorio.jpg"> 
          <source src="http://www.criar.com.br/videos/posto.mp4" type="video/mp4" />
        </video>
      </div>
    );
  }


  export {Video1,  Video2, Video3, Video4, Video5, Video6, Video7, Video8, Video9, Video10 }
  
